import { AdminLayout } from '@/components/layouts'
import { ArticleForm } from './ArticleForm'

interface Community {
  id: number
  name: string
}

interface Category {
  id: number
  name: string
  community_id: number
  parent_id: number | null
}

interface ArticleAttachment {
  id: number
  url: string
  filename: string
  content_type: string
}

interface ArticleDetail {
  id: number
  slug: string
  title: string
  excerpt: string | null
  body: string
  body_json?: string | null
  category_id: number
  community_id: number
  published_at: string | null
  comments_enabled?: boolean
  attachments?: ArticleAttachment[]
}

interface EditProps {
  article: ArticleDetail
  communities: Community[]
  categories: Category[]
}

export default function Edit({ article, communities, categories }: EditProps) {
  return (
    <AdminLayout
      title={`Modifier "${article.title}"`}
      breadcrumbs={[
        { label: 'Articles', href: '/admin/articles' },
        { label: article.title, href: `/admin/articles/${article.slug}` },
        { label: 'Modifier' }
      ]}
    >
      <div className="max-w-4xl">
        <ArticleForm
          article={{
            id: article.id,
            slug: article.slug,
            title: article.title,
            excerpt: article.excerpt || '',
            body: article.body,
            body_json: article.body_json,
            category_id: article.category_id,
            community_id: article.community_id,
            published_at: article.published_at,
            comments_enabled: article.comments_enabled,
            attachments: article.attachments
          }}
          communities={communities}
          categories={categories}
          onSubmit={`/admin/articles/${article.slug}`}
          isEdit
        />
      </div>
    </AdminLayout>
  )
}
